/** The event that opens `userId`'s profile card, from a name clicked in a chat. */
export function profileClickedEvent(userId) {
    return new CustomEvent("profile-clicked", {
        detail: { userId, chatButton: true, inGlobalContext: false },
        bubbles: true,
    });
}
class ProfileLink extends HTMLElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }
    get text() {
        return this.getAttribute("text") || "";
    }
    set text(value) {
        this.setAttribute("text", value);
        this.textContent = `@${value}`;
    }
    get userId() {
        return this.getAttribute("user-id") || "";
    }
    set userId(value) {
        this.setAttribute("user-id", value);
    }
    get suppressLinks() {
        return this.getAttribute("suppress-links") === "true";
    }
    set suppressLinks(value) {
        this.setAttribute("suppress-links", value.toString());
    }
    handleClick() {
        this.dispatchEvent(profileClickedEvent(this.userId));
    }
    // Called when the element is connected to the DOM
    connectedCallback() {
        // The template in index.html is empty; only its inline style is used.
        const template = document.querySelector("#profile-link-template");
        this.setAttribute("style", template.style.cssText);
        this.textContent = `@${this.text}`;
        // Add a click event listener to raise the custom event
        if (!this.suppressLinks) {
            this.addEventListener("click", this.handleClick);
        }
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }
}
// Define the custom element tag name
customElements.define("profile-link", ProfileLink);
